module.exports = __webpack_public_path__ + "static/media/miel-lapiquera-02.fe403ae8.jpg";